<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
    </div>
    <div class="container container-lg p-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div><h3 class="mb-3 p-2">一.下载并安装最新版Clash Verge v1.5.11 (2024年3月28日更新)</h3>
              <table>
                <thead>
                  <tr>
                    <th>Windows(64位)</th>
                    <th>Mac Intel</th>
                    <th>Mac M芯片</th>
                    <th>Linux版</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><a href="https://staticn.oss-cn-beijing.aliyuncs.com/clash-verge/1.5.11/Clash.Verge_1.5.11_x64-setup.exe">Windows 64位版下载</a> &nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td><a href="https://staticn.oss-cn-beijing.aliyuncs.com/clash-verge/1.5.11/Clash.Verge_1.5.11_x64.dmg">Mac版下载</a> &nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td><a href="https://staticn.oss-cn-beijing.aliyuncs.com/clash-verge/1.5.11/Clash.Verge_1.5.11_aarch64.dmg">Mac M芯片版下载</a> &nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td><a href="https://staticn.oss-cn-beijing.aliyuncs.com/clash-verge/1.5.11/clash-verge_1.5.11_amd64.AppImage">Linux版下载</a></td>
                  </tr>
                  <tr>
                    <td><a href="https://mirror.ghproxy.com/https://github.com/clash-verge-rev/clash-verge-rev/releases/download/v1.5.11/Clash.Verge_1.5.11_x64-setup.exe">Windows 64备用下载1</a></td>
                    <td><a href="https://mirror.ghproxy.com/https://github.com/clash-verge-rev/clash-verge-rev/releases/download/v1.5.11/Clash.Verge_1.5.11_x64.dmg">Mac备用下载1</a></td>
                    <td><a href="https://mirror.ghproxy.com/https://github.com/clash-verge-rev/clash-verge-rev/releases/download/v1.5.11/Clash.Verge_1.5.11_aarch64.dmg">Mac M备用版下载1</a></td>
                    <td><a href="https://mirror.ghproxy.com/https://github.com/clash-verge-rev/clash-verge-rev/releases/download/v1.5.11/clash-verge_1.5.11_amd64.AppImage">Linux备用下载1</a></td>
                  </tr>
                  <tr>
                    <td><a href="https://github.com/clash-verge-rev/clash-verge-rev/releases/download/v1.5.11/Clash.Verge_1.5.11_x64-setup.exe">Windows 64备用下载2</a> &nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td><a href="https://github.com/clash-verge-rev/clash-verge-rev/releases/download/v1.5.11/Clash.Verge_1.5.11_x64.dmg">Mac备用下载2</a> &nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td><a href="https://github.com/clash-verge-rev/clash-verge-rev/releases/download/v1.5.11/Clash.Verge_1.5.11_aarch64.dmg">Mac M备用版下载2</a> &nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td><a href="https://github.com/clash-verge-rev/clash-verge-rev/releases/download/v1.5.11/clash-verge_1.5.11_amd64.AppImage">Linux备用下载2</a></td>
                  </tr>
                  <tr>
                    <td><a href="https://wwv.lanzouh.com/i74za1sxsqxa">Windows 64备用下载(蓝奏云)</a></td>
                    <td>Mac版.dmg</td>
                    <td></td>
                    <td>Linux版.appimage</td>
                  </tr>
                  <tr>
                    <td><a href="https://github.com/clash-verge-rev/clash-verge-rev">Verge github开源项目地址</a></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <hr>
              <p>
                <strong><font color="red">注意1.1</font>，Clash Verge安装/运行不正常（闪退，不显示等），请尝试到"控制面板/应用管理"修复或下载安装Webview 2：<br>
                <a href="https://go.microsoft.com/fwlink/p/?LinkId=2124703">https://go.microsoft.com/fwlink/p/?LinkId=2124703</a></strong><br>
                <font color="red"><strong>**Win 7不再支持，请升级Win10或11。</strong></font>
              </p>
              <p>1.2.如果您的系统<strong>用了IP Guard类安全设置</strong>，可能<font color="red"><strong>无法正常运行Verge（表现为有任务栏图标，点击无反应）</strong></font>，请参考这篇文章以win7兼容模式运行Verge：<a href="https://jingyan.baidu.com/article/925f8cb816b94a81dce05658.html">https://jingyan.baidu.com/article/925f8cb816b94a81dce05658.html</a></p>
              <p><strong><font color="red">注意2：(MacOS提示文件已损坏)</font>，原因是开发者没有充值苹果开发者，请到终端运行命令授权；拖到app目录后(下图第一步)请打开 终端输入：<br>
                <code>sudo xattr -r -d com.apple.quarantine /Applications/Clash\ Verge.app</code><br>
                输入以上命令后 按回车，会提示需要输入电脑密码，输入密码后（密码不会显示）再按回车。最后在Lanuch Pad中启动verge</strong></p>
              <img class="mr-2" src="/img/client/macos/clash-verge/mac1.webp" width="200">
              <img class="mr-2" src="/img/client/macos/clash-verge/mac2.webp" width="300">
              <img class="mr-2" src="/img/client/macos/clash-verge/mac3.webp" width="450">
              <p><strong><font color="red">注意3</font>，请定期访问此教程页面检查客户端是否有更新，新客户端能提升速度，修复bug，提升上网体验；老版本客户端可能有未修复的漏洞，导致信息泄露，IP被封等情况。</strong></p>
              <p><strong><font color="red">注意4</font>，安装和运行Clash Verge时如安装有360等杀毒软件提示对系统有修改时，<font color="red">一律允许</font>，设置系统网络代理等必须的权限；强烈建议卸载360，使用非国产杀毒软件。</strong></p>
              <hr>
              <h3>二.购买套餐后导入订阅</h3>
              <h5>1.下载安装后在“桌面”或“开始菜单”中找到 Clash Verge 运行。（Windows与Mac版差异不大，参照进行）</h5>
              <hr>
              <div v-if="accounts.length">
                <div v-for="account in accounts" :key="account._id" class="sub-item mb-2">
                  <div class="display-6 mt-2 mb-2">{{ account.product.title }}</div>
                  <a
                    :href="`clash://install-config?url=${subLinks_1}/v1/api/clash/${account.subscription || account._id }?flag=clashmeta&?name=${account.product.title}`"
                    class="btn btn-primary btn-sm mb-2"><i class="fa fa-share"/> 点我导入到 Clash Verge</a
                    >
                  <!-- <code>{{ `${subLinks_1}/v1/api/clash/${account.subscription || account._id }` }}</code> -->
                  <base-button class="mb-2 mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_1}/v1/api/clash/${account.subscription || account._id }?name=${account.product.title}`, $event)" >复制订阅地址1</base-button>
                  <base-button class="mb-2 mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_2}/v1/api/clash/${account.subscription || account._id }?name=${account.product.title}`, $event)" >复制订阅地址2</base-button>
                </div>
                <!-- 例子 v2rayng://install-config?url=http%3A%2F%2Fexample.com&name=example
  v2rayng://install-config?url 是固定，url=后面是订阅地址 -->
              </div>
              <h5 class="display-6 mt-2 mb-2">2.点击上面按钮“点我导入到 Clash Verge“</h5>
              <h5>3.如果点击“导入没有响应” ，需要手动配置。点击👆上面“<strong>复制订阅地址</strong>” 复制订阅链接。
              </h5>
              <h5> 4.打开Clash，点击“配置”，粘贴到上方文本框中，然后点击"导入"，随后订阅套餐则会显示到下方：</h5>
              <!-- <p><a class="btn btn-hero-primary" href="javascript:void()" onclick="copy('https://izgyov0o.doggygo.top:8443/api/v1/client/4c38e9afe24e1a2213477f5bd2f06369?flag=clashmeta')"><i class="fa fa-share "></i>点我复制订阅链接</a></p> -->
              <img class="mr-2" src="/img/client/macos/clash-verge/cvr1.webp" width="500">
              <hr>
              <h5>3.点击"代理"，选择你需要的代理类型和节点：</h5>
              <img class="mr-2" src="/img/client/macos/clash-verge/cvr2.webp" width="500">
              <hr>
              <h5>4.点击"设置"启用代理，开始使用：</h5>
              <img class="mr-2" src="/img/client/macos/clash-verge/cvr3.webp" width="500">
              <hr>
              <h5>其他：</h5>
              <p>MacOS用户如需使用tun模式(代理所有流量)，需执行以下命令赋予meta内核权限：<br>
                <code>sudo chown root:admin /Applications/Clash\ Verge.app/Contents/MacOS/clash-meta</code><br>
                <code>sudo chmod +sx /Applications/Clash\ Verge.app/Contents/MacOS/clash-meta</code>
              </p>
            </div>
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    }
  }

}
</script>
<style scoped>
.search-noresults td a{
  padding: 4px 0;
  line-height: 1.6;
}
.search-noresults img {
  max-width: 100%;
}
/* @media only screen and (min-width: 600px) {
 .search-noresults img {
    max-width: 100%;
  }
} */
@media only screen and (min-width: 768px) {
  .search-noresults img {
    max-width: 80%;
  }
}
</style>
